import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as FilterIcon } from 'style/_assets/icons/icon-filter.svg';
import { Button } from 'components/form/Button/index';
import FilterTags from 'components/FilterTags';

import './FilterAndSortButton.scss';

const FilterAndSortButton = props => {
  const { displayModal, filterTags, onRemoveTagFilter, moduleName } = props;

  return (
    <FlexContainer className="items-align-center m-flex-wrap filterandsortbutton-container">
      <Button
        mrphType="standard"
        neverFullWidth
        onClick={() => {
          displayModal({ moduleName });
        }}
        datatestid={`${props.datatestid}-filter-al`}
        className="m-margB8 m-margR8 border-rad100px"
      >
        Filter & Sort{' '}
        <FilterIcon
          className="margL8 filter-icon"
          aria-label={'filtericon'}
          role="img"
        />
      </Button>
      {filterTags && (
        <FilterTags tags={filterTags} onRemoveTagFilter={onRemoveTagFilter} />
      )}
    </FlexContainer>
  );
};

export default FilterAndSortButton;
